<div class="top-bar">
  <ng-content select="[top-content]"></ng-content>
  <div class="resize-handle" (mousedown)="startResize($event, 'top')"></div>
</div>
<div class="content">
  <div class="left-bar">
    <ng-content select="[left-content]"></ng-content>
    <div class="resize-handle" (mousedown)="startResize($event, 'left')"></div>
  </div>
  <div class="main-content">
    <ng-content select="[main-content]"></ng-content>
  </div>
  <div class="right-bar">
    <ng-content select="[right-content]"></ng-content>
    <div class="resize-handle" (mousedown)="startResize($event, 'right')"></div>
  </div>
</div>
<div class="bottom-bar">
  <ng-content select="[bottom-content]"></ng-content>
  <div class="resize-handle" (mousedown)="startResize($event, 'bottom')"></div>
</div>
